export default __webpack_public_path__ + "static/media/62.eab6b2bc.png";